{
  "name": "topgolf-web-app",
  "version": "1.0.1789",
  "author": "Sterlix GmbH",
  "homepage": "https://smoothr.de/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "serve": "ionic serve --ssl --external",
    "build": "ng build",
    "build:prod": "ng build --configuration=production",
    "postbuild": "",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "deploy:dev": "~/bin/devEnv && ng build --configuration=dev-deploy && gsutil -m rsync -R ./www/browser gs://dev-topgolf-order.smoothr.de && gcloud compute url-maps invalidate-cdn-cache dev-topgolf-order-https --path \"/*\" --global",
    "deploy:prod": "~/bin/prodEnv && ng build --configuration production && gsutil -m rsync -R ./www/browser gs://topgolf-order.smoothr.de && gcloud compute url-maps invalidate-cdn-cache topgolf-order-https --path \"/*\" --global",
    "prettier": "prettier --write '**/*.{ts,js,css,html}' 1>/dev/null",
    "prepare": "husky"
  },
  "private": true,
  "dependencies": {
    "@adyen/adyen-web": "^6.29.0",
    "@angular/animations": "^21.1.1",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^21.1.1",
    "@angular/core": "^21.1.1",
    "@angular/forms": "^21.1.1",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^21.1.1",
    "@angular/platform-browser-dynamic": "^21.1.1",
    "@angular/router": "^21.1.1",
    "@angular/service-worker": "^21.1.1",
    "@ionic/angular": "^8.7.17",
    "@ionic/core": "^8.7.17",
    "@ngx-translate/core": "^17.0.0",
    "@zxing/browser": "^0.1.5",
    "@zxing/library": "^0.21.3",
    "@zxing/ngx-scanner": "^21.0.0",
    "angularx-qrcode": "^21.0.4",
    "axios": "^1.13.4",
    "dayjs": "^1.11.19",
    "ionicons": "^7.4.0",
    "ngx-scrollbar": "^18.0.0",
    "ngx-socket-io": "^4.10.0",
    "rxjs": "^7.8.2",
    "socket.io-client": "^4.8.3",
    "swiper": "^10.3.1",
    "tslib": "^2.8.1",
    "validator": "^13.15.26"
  },
  "devDependencies": {
    "@angular-devkit/architect": "^0.2101.1",
    "@angular-devkit/build-angular": "^21.1.1",
    "@angular-devkit/core": "^21.1.1",
    "@angular-devkit/schematics": "^21.1.1",
    "@angular-eslint/builder": "21.1.0",
    "@angular-eslint/eslint-plugin": "21.1.0",
    "@angular-eslint/eslint-plugin-template": "21.1.0",
    "@angular-eslint/schematics": "21.1.0",
    "@angular-eslint/template-parser": "21.1.0",
    "@angular/cli": "^21.1.1",
    "@angular/compiler": "^21.1.1",
    "@angular/compiler-cli": "^21.1.1",
    "@angular/language-service": "^21.1.1",
    "@ionic/angular-toolkit": "^12.3.0",
    "@types/google.maps": "^3.58.1",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "baseline-browser-mapping": "^2.9.18",
    "eslint": "8.57.1",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^48.11.0",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "husky": "^9.1.7",
    "patch-package": "^8.0.1",
    "postinstall-postinstall": "^2.1.0",
    "prettier": "^3.8.1",
    "replace-in-file": "^6.3.5",
    "sass": "^1.97.3",
    "ts-node": "^10.9.2",
    "typescript": "^5.9.3",
    "zone.js": "^0.15.1"
  },
  "prettier": {
    "tabWidth": 4,
    "useTabs": true,
    "singleQuote": true,
    "trailingComma": "es5",
    "bracketSpacing": true,
    "arrowParens": "avoid",
    "printWidth": 140,
    "semi": true
  },
  "description": "Topgolf Web App"
}
